import React,{ useState, useEffect } from "react";
import { Select, Input, Button, Form, Alert } from 'antd';
import axios from 'axios';

import {
    DeleteOutlined,
    EditOutlined
} from '@ant-design/icons';

function EditServiceButtons( { 
        productCategory, 
        productId,
        setInternetDrawerOpen,
        setTvDrawerOpen,
        setPhoneDrawerOpen
    } ) {

    const [deletingItemFromCart, setDeletingItemFromCart] = useState(false);

    const siteDomain = headerVars.siteDomain;

    const handleEditSelectedProduct = ( productCategory ) => {
        switch( productCategory ) {
            case 'internet-packages': 
            setInternetDrawerOpen( true );
            break;
            case 'tv-packages': 
            setTvDrawerOpen( true );
            break;
            case 'phone-packages': 
            setPhoneDrawerOpen( true );
            break;
        }
    }

    const handleDeleteSelectedProduct = ( productCategory, productId ) => {
        //console.log("productId: ", productId );
        setDeletingItemFromCart( true );
        let form_data = new FormData;
        form_data.append('action', 'startca_remove_item_from_cart');
        form_data.append('product_category', productCategory);
        form_data.append('product_id', productId);
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log( response.data );
            let serviceCount = response.data;
            setDeletingItemFromCart( false );
            document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
            jQuery( '.header-cart-icon' ).html('<span class="cart-contents-quantity">'+serviceCount+'</span>');
        })
        .catch(function (error) {
            console.log(error);
            setDeletingItemFromCart( false );  
        })
        .finally(function () {
            // always executed 
        }); 
    }
    
    return ( (
            productCategory == 'internet-packages' ||
            productCategory == 'tv-packages' ||
            productCategory == 'phone-packages'
        ) ? <>
                <Button 
                    type="primary"
                    size='small'
                    style={{ padding: 0, marginRight: '0.2rem' }}
                    shape="circle" 
                    icon={ < EditOutlined /> }
                    onClick={ () => handleEditSelectedProduct( productCategory ) }
                />
                <Button 
                    type="primary"
                    size='small'
                    style={{ padding: 0, marginRight: '0.5rem', backgroundColor: '#ff4d4f' }}
                    shape="circle"
                    loading={ deletingItemFromCart } 
                    icon={ < DeleteOutlined /> }
                    onClick={ () => handleDeleteSelectedProduct( productCategory, productId ) }
                />
            </>
          : null
        
    )
}

export default EditServiceButtons